module.exports = __webpack_public_path__ + "img/ICBC.e48ef509.png";